import { CircularProgress, Container } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
import { CollectionOrderItem, ICollectOrderItemSource } from "../components-molecules/CollectionOrderItem";
import { CollectOrderListModel } from "../redux/actions/collectOrders";

interface ICollectionOrdersListProps {
  data: CollectOrderListModel[];
  totalCount: number;
  source: ICollectOrderItemSource;
  loadMore: () => void;
}

export function CollectionOrdersList({
  data,
  totalCount,
  source,
  loadMore
}: ICollectionOrdersListProps) {
  const handleItemClick = (id: string) => {
    window.location.href = `/delivery-order/${id}`;
  };

  const currentCount = data.map((m: any) => m.Deliveries).flat().length;
  return (
    <InfiniteScroll
      style={{ overflow: "hidden" }}
      dataLength={currentCount} // This is important field to render the next data
      next={() => loadMore()}
      scrollThreshold={0.8}
      hasMore={totalCount > currentCount}
      loader={
        <Container style={{ width: "100%" }}>
          <CircularProgress />
        </Container>
      }
    >
      {data.map((item: any, index: number) => (
        <CollectionOrderItem
          index={index}
          key={item.Id}
          data={item}
          source={source}
          onClick={handleItemClick}
        />
      ))}
    </InfiniteScroll >
  );
}
